import styles from "./BundlesHomePage.module.css";
import { BundleTypes } from "./constants";

export type CardType = {
    label: string;
    bundle_type: string;
    icon: React.ReactNode;
    desc: string;
    min: number;
    line: string;
    useCases: string[];
    search_tags: string[];
};

export const BundleCards = [
    {
        label: "Standard Bundle",
        bundle_type: BundleTypes.STANDARD,
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/Standard.png"} alt={"Standard Bundle"} />
            </>
        ),
        desc: "Sell combo of different products together with a discount.",
        min: 2,
        line: styles.line2,
        useCases: [
            "Buy Products A, B, and C together for $100.",
            "Buy Products A and B at 20% off, along with a free gift",
            "Buy A and B at 20% off, plus a free gift.",
            "Buy Products A and B at 50% OFF",
            "Purchase a fixed set of products together (complementary products, frequently bought together products, new product trial, etc.)",
        ],
        search_tags: ["standard_bundle", "standard", "Standard Bundle", "bundle", "bundles"],
    },
    {
        label: "Quantity Breaks / Volume Discount",
        bundle_type: BundleTypes.VOLUME_DISCOUNT,
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/Volume.png"}
                    alt={"Quantity Breaks / Volume Discount"}
                />
            </>
        ),
        desc: "Sell one product with different discount offers.",
        min: 2,
        line: styles.line2,
        useCases: [
            "Buy 1 at full price, 2 for 5% OFF, 3+ for 10% OFF.",
            "Buy 1 with $10 OFF, 2 with $25 OFF, 3 with $50 OFF.",
            "Purchase consumables in bulk to avoid repeat purchases",
            "Save more when you purchase larger quantities of the same product for your business",
        ],
        search_tags: [
            "volume_bundle",
            "volume",
            "quantity",
            "Quantity Breaks",
            "Volume Discount",
            "bundle",
            "bundles",
            "Quantity Breaks / Volume Discount",
        ],
    },
    {
        label: "Mix & Match",
        bundle_type: BundleTypes.MIX_MATCH,
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/M&M.png"} alt={"Mix & Match"} />
            </>
        ),
        desc: "Sell mix products and enjoy discount",
        min: 2,
        line: styles.line3,
        useCases: [
            <>
                <span>Build your bundle:</span> Choose any 3 items, get 20% OFF.
            </>,
            "Buy 4 T-shirts for $50, 5 for $60, or 6 for $65.",
            "Purchase a specific quantity of products from the list to unlock greater savings",
            <>
                <span>Sitewide Offers:</span> Buy any 4 products sitewide with 20% discount
            </>,
            <>
                <div>Bulk Buy:</div>
                <div style={{ marginLeft: 20 }}>
                    <ul>
                        <li>Buy any 3–6 products and get 10% OFF</li>
                        <li>Buy 7–20 products and get 25% OFF</li>
                        <li>Buy 20+ products and get 30% OFF</li>
                    </ul>
                </div>
            </>,
        ],
        search_tags: ["mnm_bundle", "mix", "match", "Mix & Match", "mix and match", "bundle", "bundles"],
    },
    {
        label: "Buy N, Discount on Cheapest / Costliest",
        bundle_type: BundleTypes.BUY_N,
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/BuyN.png"} alt={"Buy N"} />
            </>
        ),
        desc: "Sell N products and enjoy discount",
        min: 3,
        line: styles.line3,
        useCases: ["Buy 2, Get 1 Free", "Buy More, Save More (Up to 60% OFF)", "Buy 3, Get 1 at 30% OFF"],
        search_tags: ["buyn", "buy-n", "buy n", "bundle", "bundles"],
    },
    {
        label: "BXGY Bundle",
        bundle_type: BundleTypes.BXGY,
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/Bxgy.png"} alt={"BXGY Bundle"} />
            </>
        ),
        desc: "Sell X products and enjoy discount on Y products.",
        min: 2,
        line: styles.line2,
        useCases: [
            "Buy one, get one free on the same or another product.",
            "Buy A and get a second A at 50% OFF, or B for $5.",
            "Buy Product A and get Product B for $5",
            "Buy Product A and get Product B for free",
            "Buy Product A and get a free gift",
            "Buy Products A+B and get a free gift",
            "Buy ProductA+B and get a free shipping (Soon)",
            "Buy X products and get Y products at a discount or for free",
        ],
        search_tags: ["bxgy_bundle", "BXGY Bundle", "bxgy", "buy x get y", "bundle", "bundles"],
    },
    {
        label: "Frequently Bought Together",
        bundle_type: BundleTypes.FBT,
        icon: (
            <>
                <>
                    <img
                        width={"100%"}
                        style={{ objectFit: "cover" }}
                        src={"/svgs/FBT.png"}
                        alt={"Frequently Bought Together"}
                    />
                </>
            </>
        ),
        desc: "Sell X products and enjoy discount on Y products.",
        min: 2,
        specialTag: "",
        line: styles.line2,
        useCases: [
            "Bundle complementary products (e.g., laptop + mouse).",
            "Offer discounts on related items like console + controller.",
            "Suggest accessory bundles for main products (e.g., phone + case + screen protector).",
            "Highlight combinations frequently purchased together (e.g., shampoo + conditioner).",
            "Discount on product + maintenance kit bundles (e.g., bicycle + tire pump).",
        ],
        search_tags: ["fbt_bundle", "frequently_bought_together", "fbt", "bundle", "bundles"],
    },
    {
        label: "Product Add-ons",
        bundle_type: BundleTypes.PRODUCT_ADDONS,
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/AddOn.png"} alt={"Product Add-ons"} />
            </>
        ),
        desc: "Enhance your main product with additional accessories or upgrades.",
        min: 2,
        specialTag: "",
        line: styles.line2,
        useCases: [
            "Discount an essential accessory (e.g., 20% OFF screen protector).",
            "Give a free complementary item like a scarf with a coat.",
            "Increase value by adding a bonus item (e.g., Buy a premium coffee machine, add pack of coffee beans for free ).",
            "Offer a discount on a matching accessory (e.g., Buy a dress, get 20% off a matching handbag).",
            "Apply a fixed discount on an additional product (e.g., Buy sneakers and get $10 off a pair of socks).",
        ],
        search_tags: ["addon_bundle", "product", "add-on", "add-ons", "add on", "add ons", "bundle", "bundles"],
    },
    {
        label: "Product Add-ons (Popup)",
        bundle_type: BundleTypes.PRODUCT_ADDONS_POPUP,
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/AddOnPopup.png"}
                    alt={"Product Add-ons"}
                />
            </>
        ),
        desc: "Enhance your main product with additional accessories or upgrades with popup.",
        min: 2,
        specialTag: "",
        line: styles.line2,
        useCases: [
            "Discount an essential accessory (e.g., 20% OFF screen protector).",
            "Give a free complementary item like a scarf with a coat.",
            "Increase value by adding a bonus item (e.g., Buy a premium coffee machine, add pack of coffee beans for free ).",
            "Offer a discount on a matching accessory (e.g., Buy a dress, get 20% off a matching handbag).",
            "Apply a fixed discount on an additional product (e.g., Buy sneakers and get $10 off a pair of socks).",
        ],
        search_tags: [
            "addon_popup_bundle",
            "Product Add-ons (Popup)",
            "popup",
            "add-on",
            "product",
            "add-on",
            "add-ons",
            "add on",
            "add ons",
            "bundle",
            "bundles",
        ],
    },

    // {
    //     label: "BXGY Bundle - Sectional",
    //     bundle_type: BundleTypes.BXGY_SECTIONAL,
    //     icon: (
    //         <>
    //             <img
    //                 width={"100%"}
    //                 style={{ objectFit: "cover" }}
    //                 src={"/svgs/BxgySectional.png"}
    //                 alt={"BXGY Bundle - Sectional"}
    //             />
    //         </>
    //     ),
    //     desc: "Sell X products and enjoy discount on Y products.",
    //     tag: "Coming Soon",
    //     min: 2,
    //     line: styles.line2,
    //     useCases: [
    //         "Buy any 2 shirts and get a free gift from New Arrivals.",
    //         "Buy a shirt and pants set and get another set for $50 OFF.",
    //         "Build your own happy meal and enjoy fries with a Coke at 50% OFF.",
    //         <>
    //             <span style={{ fontWeight: 650 }}> Custom BXGY Bundles:</span> Select specific quantities from different
    //             product collections to unlock discounts on any 2 products of your choice.
    //         </>,
    //     ],
    // },
];

export const CartCards = [
    {
        label: "Slide Cart",
        bundle_type: "slide-cart",
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/Cart.png"} alt={"Slide Cart"} />
            </>
        ),
        desc: "",
        min: 4,
        specialTag: "",
        line: styles.line2,
        useCases: ["Upsells", "Tiered Rewards", "Product Add On", "Subscription Upgrade", "Recommendations"],
        search_tags: ["slide_cart", "slide cart", "cart", "side cart"],
    },
    {},
    {},
    {},
    {},
    {},
];

export const AiCards = [
    {
        label: "Get AI Suggestions For Bundles",
        bundle_type: "slide-cart",
        icon: (
            <>
                <img width={"100%"} style={{ objectFit: "cover" }} src={"/svgs/AiBundles.png"} alt={"AI Bundles"} />
            </>
        ),
        desc: "",
        min: 4,
        specialTag: "",
        line: styles.line2,
        useCases: [
            "AI suggests high-converting bundles for your store",
            "1 click publish",
            "Editable bundle drafts.",
            "Bulk publish bundles",
        ],
        search_tags: ["ai_bundle", "ai", "ai bundle", "ai-bundles", "recommendation", "bundle", "bundles"],
    },
    {},
    {},
    {},
    {},
    {},
];

export const BundleBuilderCards = [
    {
        label: "Build Your Own Box",
        bundle_type: BundleTypes.BUNDLE_BUILDER,
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/BundleBuilder.png"}
                    alt={"BXGY Bundle - Sectional"}
                />
            </>
        ),
        desc: "Build your own bundle box",
        min: 2,
        line: styles.line1,
        useCases: [
            <>
                <strong style={{ color: "#464646" }}>Appears on a dedicated bundle page</strong> - Your customers build
                a box from scratch on a separate, standalone page.
            </>,
            "Make your toy box – pick 3 games, 2 crafts & 1 surprise toy for a fun, custom play set.",
            "Create a gift set – mix soaps, lotions & candles to build a perfect gift for any occasion.",
            "Build your outfit – choose a top, bottom & accessory to get 15% OFF your custom look.",
            "Mix & match chocolate – select 6 bars from 20+ flavors and save on every bundle.",
        ],
        search_tags: ["bundle_builder", "build your own", "box", "bundle builder", "builder", "bundle", "bundles"],
        footer_layout: "bottom",
    },
    {
        label: "Product Page Bundle Builder",
        bundle_type: BundleTypes.BB_PLACEHOLDER,
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/BBPlaceholder.svg"}
                    alt={"Product Page Bundle Builder"}
                />
            </>
        ),
        desc: "Build your own bundle box",
        min: 2,
        line: styles.line1,
        useCases: [
            <>
                <strong style={{ color: "#464646" }}>Appears on the product page</strong> - The bundle builder is shown
                directly on the product page so customers can build a bundle without leaving the page.
            </>,
            "Make your toy box – pick 3 games, 2 crafts & 1 surprise toy for a fun, custom play set.",
            "Create a gift set – mix soaps, lotions & candles to build a perfect gift for any occasion.",
            "Build your outfit – choose a top, bottom & accessory to get 15% OFF your custom look.",
            "Mix & match chocolate – select 6 bars from 20+ flavors and save on every bundle.",
        ],
        search_tags: [
            "bundle_builder",
            "bb placeholder",
            "build your own",
            "box",
            "bundle builder",
            "builder",
            "bundle",
            "bundles",
        ],
    },
    {
        label: "Mix & Match (Sectional)",
        bundle_type: BundleTypes.MIX_MATCH_SECTIONAL,
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/MixMatchSectional.png"}
                    alt={"Mix & Match (Sectional)"}
                />
            </>
        ),
        desc: "Sell mix products and enjoy discount",
        min: 2,
        line: styles.line3,
        useCases: [
            "Build your outfit – mix any 3 styles (Polos, Solids, Relaxed Fit) and get 10% OFF.",
            "Buy 3 for $15, 5 for $22, or 7 for $28 – mix chips, nuts, and sweets your way.",
            "Create your routine – cleanser, serum, moisturizer – bundle 3, get 15% OFF.",
            "Pick any 3 from rings, earrings, or bracelets – save 20% on your custom set.",
        ],
        search_tags: ["mnm_bundle", "mix", "match", "sectional", "bundle builder", "builder", "bundle", "bundles"],
    },
    {},
    {},
    {},
    {},
];

export const PostPurchaseCards = [
    {
        label: "Post Purchase",
        bundle_type: "post-purchase",
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/PostPurchaseImage.png"}
                    alt={"Post Purchase"}
                />
            </>
        ),
        desc: "",
        min: 4,
        specialTag: "",
        line: styles.line2,
        useCases: ["One Click Upsells", "AI Recommendations", "Multiple Offers"],
        search_tags: ["post_purchase", "post purchase", "post-purchase", "upsell"],
    },
    {},
    {},
    {},
    {},
    {},
];

export const ThankYouPageCards = [
    {
        label: "Thank You Page",
        bundle_type: "thank-you-page",
        icon: (
            <>
                <img
                    width={"100%"}
                    style={{ objectFit: "cover" }}
                    src={"/svgs/ThankYouPageImage.png"}
                    alt={"Thank You Page"}
                />
            </>
        ),
        desc: "",
        min: 4,
        specialTag: "",
        line: styles.line2,
        useCases: ["Upsells", "AI Recommendations", "Multiple Offers"],
        search_tags: ["thank_you_page", "thank you", "Thank You Page", "thank-you-page", "upsell", "thank you page"],
    },
    {},
    {},
    {},
    {},
    {},
];
